import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, AlertTriangle } from "lucide-react";

export default function TrialBanner() {
  const [status, setStatus] = useState(null);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/status");
      setStatus(data);
    } catch {
      setStatus(null);
    }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60 * 1000);
    return () => clearInterval(t);
  }, [load]);

  if (!status || !status.has_billing) return null;
  // Never show for enterprise super-admin.
  if (status.plan_key === "enterprise") return null;

  if (status.status === "trialing") {
    const days = status.days_left ?? 0;
    const color =
      days <= 3 ? "bg-amber-50 border-amber-200 text-amber-800" : "bg-blue-50 border-blue-200 text-blue-800";
    return (
      <div
        className={"px-4 py-2 border-b flex items-center gap-2 text-sm " + color}
        data-testid="trial-banner"
      >
        <Sparkles className="w-4 h-4" />
        <span>
          <b>{status.plan_name}</b> trial · {days} day{days === 1 ? "" : "s"} left ·
          {" "}using <b>{status.used_employees}</b> / {status.employee_cap} employees.
        </span>
      </div>
    );
  }
  if (status.status === "past_due" || status.status === "canceled") {
    return (
      <div className="px-4 py-2 border-b bg-red-50 border-red-200 text-red-800 flex items-center gap-2 text-sm" data-testid="trial-banner">
        <AlertTriangle className="w-4 h-4" />
        <span>
          Your <b>{status.plan_name}</b> plan is <b>{status.status}</b>. Renew from
          Billing (available soon) to keep adding employees and sending messages.
        </span>
      </div>
    );
  }
  return null;
}
